export const merSETASDE = 'merSETASDE';
export const CategoryInterventions = merSETASDE + '/CategoryInterventions';
export const Search = merSETASDE + '/Search';
